import React from "react";
import { Box } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { duration, ease, useReducedMotion } from "../../theme/foundations/motion";

export interface HighlightProps {
  children: React.ReactNode;
  /** On navy surfaces the swipe is translucent green; on light surfaces it is leaf.200. */
  onDark?: boolean;
  /** Seconds before the swipe starts (default 0.15; login uses 0.7). */
  delay?: number;
}

/**
 * Highlighter swipe under a key word — used exactly twice: dashboard "Welcome <Highlight onDark>back</Highlight>" and the login headline.
 * Renders fully drawn under prefers-reduced-motion.
 */
export const Highlight: React.FC<HighlightProps> = ({ children, onDark = false, delay = 0.15 }) => {
  const reduce = useReducedMotion();
  return (
    <Box as="span" position="relative" zIndex={0} display="inline-block" sx={{ isolation: "isolate" }}>
      {children}
      <motion.span
        aria-hidden
        style={{
          position: "absolute",
          left: "-0.1em",
          right: "-0.1em",
          bottom: "0.08em",
          height: "0.42em",
          borderRadius: 2,
          zIndex: -1,
          background: onDark ? "rgba(107,191,89,0.55)" : "var(--chakra-colors-leaf-200)",
          transformOrigin: "left center",
        }}
        initial={reduce ? false : { scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={reduce ? { duration: 0 } : { duration: duration.story, ease: ease.emphasized, delay }}
      />
    </Box>
  );
};
